// Booking attribution — fire-and-forget analytics for conversion-driving UX
// surfaces (announcement bar, exit modal, social proof toast, hero CTA, etc).
//
// Backend: POST /api/booking/attribution
// Admin summary: GET /api/admin/booking/attribution/summary?days=30
//
// Safe to call from a click handler with `keepalive` so it survives page nav.

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "bookingAttributionSessionId";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid =
        (crypto.randomUUID && crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return "";
  }
}

/**
 * Record a booking-intent event.
 * @param {string} source - one of: announcement_bar | exit_modal | social_proof_toast
 *                          | hero_cta | sticky_cta | service_page | geo_page
 *                          | money_page | footer | other
 * @param {string} [action='click'] - click | book_now | call | message
 * @param {object} [meta] - optional extra tags (e.g. { campaign, service })
 */
export function trackBookingAttribution(source, action = "click", meta = {}) {
  if (typeof window === "undefined") return;
  const body = JSON.stringify({
    source,
    action,
    path: window.location.pathname + window.location.search,
    session_id: getSessionId(),
    meta,
  });
  try {
    // sendBeacon is ideal because it survives page unload (clicking a link that
    // navigates away). Falls back to fetch for browsers that don't support it.
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(`${API}/booking/attribution`, blob);
      return;
    }
    fetch(`${API}/booking/attribution`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* attribution failures must never break user flow */
  }
}

export default trackBookingAttribution;
